//#region imports
import { Box } from '@mui/material';
import { Stack } from '@mui/system';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DataGridPro, GridPagination } from '@mui/x-data-grid-pro';
import {
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
  faHelmetSafety,
} from '@fortawesome/free-solid-svg-icons';

import customAxios from '../../utils/customAxios';
import { GlobalVariables } from '../../globalVar';
import { useTableLocale } from '../../hooks/useTableLocale';
import { useTranslationHook } from '../../hooks/UseTranslationHook';

library.add(
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble
);

//#endregion

export const TrackingTableAxios = ({
  pins,
  receiveTechADataTable,
  receiveTechNADataTable,
}) => {
  const [techAData, setTechAData] = useState([]);
  const [techNAData, setTechNAData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: 0,
  });

  const {
    dashboardDTTechsName,
    dashboardDTTechsPhone,
    noTechsString,
    dashboardDTTechsO,
    dashboardDTTechsF,
    dashboardDTTechsD,
    dashboardDTTechsTitle,
  } = useTranslationHook();

  const endpoint = `${GlobalVariables.getURL()}techsDashboard`;

  const getData = async () => {
    setIsLoading(true);

    try {
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });
      const techAData = response.data['Tecnicos Asignados'].map((techA) => {
        return {
          id: techA.tech_id,
          ...techA,
        };
      });
      const techNAData = response.data['Tecnicos Libres'].map((techNA) => {
        return {
          id: techNA.tech_id,
          ...techNA,
        };
      });

      setTechAData(techAData);
      receiveTechADataTable(techAData);
      setTechNAData(techNAData);
      receiveTechNADataTable(techNAData);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const CustomFooterTracking = () => {
    return (
      <Box
        display='flex'
        flexDirection='column'
        alignItems='left'
        justifyContent='center'
        m={1}
        height='100%'
      >
        <span>
          <strong>{dashboardDTTechsTitle}</strong>
        </span>
        <span>
          <FontAwesomeIcon icon={faHelmetSafety} color='#57A65C' />{' '}
          {dashboardDTTechsF}
        </span>
        <span>
          <FontAwesomeIcon icon={faHelmetSafety} color='red' />{' '}
          {dashboardDTTechsO}
        </span>
        <span>
          <FontAwesomeIcon icon={faHelmetSafety} color='#c6cad1' />{' '}
          {dashboardDTTechsD}
        </span>
      </Box>
    );
  };

  // Columnas
  const trackingColumns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 60,
    },
    {
      field: 'name',
      headerName: dashboardDTTechsName,
      width: 300,
      renderCell: (params) => {
        const isTechA = techAData.some((tech) => tech.tech_id === params.id);
        const isTechNA = techNAData.some((tech) => tech.tech_id === params.id);
        const fillColor = isTechA ? 'red' : isTechNA ? '#57A65C' : '#187bcd';

        const isOnMap = pins.some((tech) => tech.techId === params.id);

        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <FontAwesomeIcon
              icon={faHelmetSafety}
              style={{
                color: isOnMap ? fillColor : '#c6cad1',
                marginRight: '5px',
                fontSize: '1.5rem',
              }}
            />{' '}
            <span>{params.row.name}</span>
          </div>
        );
      },
    },
    {
      field: 'phone',
      headerName: dashboardDTTechsPhone,
      width: 120,
    },
  ];

  const locale = useTableLocale();

  return (
    <>
      <DataGridPro
        pagination
        loading={isLoading}
        initialState={{
          sorting: {
            sortModel: [{ field: 'id', sort: 'desc' }],
          },
        }}
        rows={techAData.concat(techNAData)}
        columns={trackingColumns}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        pageSizeOptions={[5, 10, 15]}
        onRowClick={(e) => {
          navigate(`/tech/details/${e.id}`);
        }}
        slots={{
          noRowsOverlay: () => (
            <Stack height='100%' alignItems='center' justifyContent='center'>
              {noTechsString}
            </Stack>
          ),
          footer: () => (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                height: 'fit-content',
              }}
            >
              <CustomFooterTracking />
              <GridPagination />
            </div>
          ),
        }}
        localeText={locale.components.MuiDataGrid.defaultProps.localeText}
      />
    </>
  );
};
